import React, { useCallback } from 'react';
import { format } from 'date-fns';
import { Paper, Typography, IconButton } from '@mui/material';
export type EventLike = { date: Date; value: number; label?: string };


export const useDragSelection = ({ onSelectRange, confirmBeforeApply }: { onSelectRange?: (timeRange: [Date, Date]) => void; confirmBeforeApply?: boolean }) => {
  const [isDragging, setIsDragging] = React.useState(false);
  const [dragFirst, setDragFirst] = React.useState<Date | null>(null);
  const [dragCurrent, setDragCurrent] = React.useState<Date | null>(null);
  const [dragStart, dragEnd] = dragFirst && dragCurrent ? [dragFirst < dragCurrent ? dragFirst : dragCurrent, dragFirst > dragCurrent ? dragFirst : dragCurrent] : [null, null];
  const [confirmOpen, setConfirmOpen] = React.useState(false);
  const dragRangeRef = React.useRef({ isDragging, dragStart, dragEnd, onSelectRange, confirmBeforeApply });
  React.useEffect(() => { dragRangeRef.current = { isDragging, dragStart, dragEnd, onSelectRange, confirmBeforeApply }; }, [isDragging, dragStart, dragEnd, onSelectRange, confirmBeforeApply]);


  const updateDrag = useCallback((date: Date, isStart?: boolean) => {
    if (!isStart && !dragRangeRef.current?.isDragging) return;
    // if (isStart) { setIsDragging(true); setDragFirst(date); }
    setIsDragging(i => {
      if (!i) setDragFirst(date);
      return true;
    });
    setDragCurrent(date);
  }, []);

  // // Confirm chip state
  // const cancelDrag = useCallback(() => {
  //   setIsDragging(false);
  //   setDragFirst(null);
  //   setDragCurrent(null);
  //   setConfirmOpen(false);
  // }, []);

  const commitDrag = useCallback((confirm?: boolean) => {
    const { isDragging, dragStart, dragEnd, onSelectRange, confirmBeforeApply } = dragRangeRef.current || {};
    // console.log('commitDrag', { confirm, dragStart, dragEnd });
    if (confirm === false) {
      setIsDragging(false);
      setDragFirst(null);
      setDragCurrent(null);
      setConfirmOpen(false);
    }
    else if (dragStart && dragEnd) {
      const from = dragStart;
      // const to = dragEnd === dragStart ? new Date(dragStart.getTime() + 24*60*60*1000) : dragEnd;
      const to = new Date(dragEnd.getTime() + 24*60*60*1000 - 1); // include full last day
      // console.log(onSelectRange)
      if (!onSelectRange) return;
      // console.log('committing drag', { from, to });
      if (confirmBeforeApply && confirm !== true) {
        setIsDragging(false);
        setConfirmOpen(true);
        console.log('showing confirm')
        return;
      }
      // console.log('applying drag', { from, to });
      onSelectRange([from, to]);
      setIsDragging(false);
      setDragFirst(null);
      setDragCurrent(null);
      setConfirmOpen(false);
    }
    else {
      // console.log('no drag to commit', { dragStart, dragEnd });
    }
    
  }, []);


  // Global safety net: if the pointer is released outside the svg or the app loses focus, end drag
  React.useEffect(() => {
    if (!dragFirst) return;
    const onUp = () => commitDrag();
    const onBlur = () => commitDrag();
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    window.addEventListener('blur', onBlur);
    return () => {
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      window.removeEventListener('blur', onBlur);
    };
  }, [commitDrag, dragFirst]);

  return { 
    confirmOpen, setConfirmOpen,
    isDragging, dragStart, dragEnd,
    updateDrag, commitDrag

    // isDragging, dragFirst, dragCurrent, dragStart, dragEnd, 
    // // setIsDragging, setDragFirst, setDragCurrent, commitDrag, cancelDrag, confirmOpen, setConfirmOpen 
  };
};

export const ConfirmTimeRangeChip = React.memo(({ from, to, onConfirm, onCancel }: { from: Date; to: Date; onConfirm: () => void; onCancel: () => void }) => {
  return (
    <Paper elevation={3} sx={{ px: 1, py: 0.5, borderRadius: 999, display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="caption" sx={{ mx: 0.5 }}>
        Set time range: <b>{format(from, 'PP')}</b> – <b>{format(to, 'PP')}</b>
      </Typography>
      <IconButton size="small" aria-label="Cancel" onClick={onCancel}>
        <span style={{ fontSize: 12 }}>✕</span>
      </IconButton>
      <IconButton size="small" color="primary" aria-label="Apply" onClick={onConfirm}>
        <span style={{ fontSize: 12 }}>✓</span>
      </IconButton>
    </Paper>
  );
});
